import { render, staticRenderFns } from "./index3.6.vue?vue&type=template&id=3a213a13&scoped=true"
import script from "./index3.6.vue?vue&type=script&lang=js"
export * from "./index3.6.vue?vue&type=script&lang=js"
import style0 from "./index3.6.vue?vue&type=style&index=0&id=3a213a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a213a13",
  null
  
)

export default component.exports